import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';


const Services = () => {
    const [services, setServices] = useState([]);
    const navigate = useNavigate();
    const navigateToPackageDetail = id => {
        navigate(`/package/${id}`)
    }

    useEffect(() => {
        fetch('services.json')
            .then(res => res.json())
            .then(data => setServices(data));
    }, [])
    return (
        <div className='container'>
            <div className='row mx-auto'>
                <h3 className='text-center py-3'>Our Exclusive</h3>
                <h2 className='text-center'>See Our <span className='text-danger'>Packages</span> </h2>
                {
                    // services.map(service => <Service
                    //     key={service.id}
                    //     service={service}
                    // ></Service>)
                    services.map(service => <div key={service.id} className="card mx-auto pt-2 col-12 col-sm-12 col-md-6 col-lg-4" style={{ width: '18rem' }}>
                        <img src={service.img} className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h2 className="card-title">{service.price}</h2>
                            <h4>{service.name}</h4>
                            <p className="card-text">{service.description}</p>
                            <button onClick={() => navigateToPackageDetail(service.id)} className="btn btn-primary btn-font">Proceed To Checkout</button>
                        </div>
                    </div>)
                }
            </div>
        </div>
    );
};

export default Services;